import { CdxDocument } from './cdx-document';
import { Entity } from './Entity';

export enum BasketSelectStatus {
  SELECT_ACTIVE,
  SELECT_INACTIVE
}

export enum ActionStatus {
  DISABLED,
  ACTIVE,
  READONLY
}

export enum NexiaBasketObjectKeys {
  DOCUMENTS = 'documents',
  ENTITIES = 'entities'
}

export class NexiaBasketObject {
  id: string;
  details?: CdxDocument | Entity;
  loadedStatus?: number; // 500, 404, 200

  constructor(id: string) {
    this.id = id;
  }
}
